import { sendGenericErrorNotification } from '@msdk/common'
import {
  initializeEventsAPI,
  initializeExceptionsAPI,
  MetricsExporter,
  MetricsInstrumentation,
  TracesExporter,
  TracingInstrumentation,
} from '@msdk/telemetry'

/**
 * The function initializes telemetry instrumentation for tracing and metrics.
 * @returns The function `initializeTelemetry` returns an instance of the `TracingInstrumentation`
 * class.
 */
export function initializeTelemetry(): TracingInstrumentation {
  const t = new TracingInstrumentation(
    {
      app: {
        name: window.__APP_CONFIG__.APP_NAME as string,
        version: window.__APP_CONFIG__.APP_VERSION as string,
      },
      exporterType: TracesExporter.OTLP,
      headers: { authorization: `Basic ${window.__APP_CONFIG__.OTEL_APM_TOKEN as string}` },
      instrumentationOptions: {
        propagateTraceHeaderCorsUrls: [
          `${window.__APP_CONFIG__.API as string}`,
          `${window.__APP_CONFIG__.AUTHORITY as string}`,
        ],
      },
      onExceptionAction: sendGenericErrorNotification,
    },
    window.__APP_CONFIG__.OTEL_APM as string,
  )
  t.initialize()

  const m = new MetricsInstrumentation(
    {
      app: {
        name: window.__APP_CONFIG__.APP_NAME as string,
        version: window.__APP_CONFIG__.APP_VERSION as string,
      },
      exporterType: MetricsExporter.OTLP,
      headers: { authorization: `Basic ${window.__APP_CONFIG__.OTEL_APM_TOKEN as string}` },
    },
    window.__APP_CONFIG__.OTEL_APM as string,
  )
  m.initialize()

  return t
}

export const traceError = initializeExceptionsAPI().traceError
export const traceEvent = initializeEventsAPI().pushEvent
export const runInEventSpan = initializeEventsAPI().runInEventSpan
